module.exports = __webpack_public_path__ + "static/headerRightBg-63db104aa3b9564ac743c7d4d24ebe7c.png";